import { http } from '@/http'

export default {
  list(params) {
    return http.get('/leaves', { params })
  },
  get(id) {
    return http.get(`/leaves/${id}`)
  },
  create(data) {
    return http.post('/leaves', data)
  },
  update(id, data) {
    return http.put(`/leaves/${id}`, data)
  },
  cancel(id) {
    return http.put(`/leaves/${id}/cancel`)
  },
  annulLeave(id, reason) {
    return http.patch(`/leaves/${id}/annul`, { reason })
  },
  annulBatch(ids, reason) {
    return http.patch('/leaves/annul-batch', { ids, reason })
  },
  uploadDocument(id, file) {
    const formData = new FormData()
    formData.append('file', file)
    // No fijamos Content-Type: el navegador lo establece con el boundary del multipart
    return http.post(`/leaves/${id}/document`, formData)
  },
  downloadDocument(id) {
    return http.get(`/leaves/${id}/document`, { responseType: 'blob' })
  },
  download(filters) {
    return http.post('/leaves/xlsx', filters, { responseType: 'blob' })
  },
}
